import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/footer";
import LoadingPage from "../../Components/layouts/loading";
import { Toast } from "../../CustomComponent/toast";
import performRequest from "../../api/request";
import { FcMultipleCameras } from "react-icons/fc";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";
import {
  FaArrowLeft,
  FaArrowRight,
  FaPaperPlane,
  FaShareAlt,
  FaPlus,
} from "react-icons/fa";

const ViewPerFolderFarmMedia = () => {
  let userData = useSelector((store) => store.login.user);
  const { subfolder } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mediaList, setMediaList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [zoomScale, setZoomScale] = useState(1);
  const [showManualModal, setShowManualModal] = useState(false);
  const [senderName, setSenderName] = useState("");
  const [whatsappNo, setWhatsappNo] = useState("");

  const videoRef = useRef(null);
  // testing

  const isAdmin =
    userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
    userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
    userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN;

  useEffect(() => {
    if (!subfolder) return;

    const fetchMedia = async () => {
      try {
        setLoading(true);
        const res = await performRequest(
          "GET",
          `/farmMedia/farmTrainingMedia/subfolder/${subfolder}`
        );

        if (res.status === 200) {
          setMediaList(res.data?.files || []);
        }
      } catch (err) {
        CustomErrorResponse(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMedia();
  }, [subfolder]);

  /* 🔁 NAVIGATION */
  const nextMedia = () => {
    videoRef.current?.pause();
    setZoomScale(1);
    setSelectedIndex((prev) => (prev + 1) % mediaList.length);
  };

  const prevMedia = () => {
    videoRef.current?.pause();
    setZoomScale(1);
    setSelectedIndex((prev) => (prev === 0 ? mediaList.length - 1 : prev - 1));
  };

  const closeModal = () => {
    videoRef.current?.pause();
    setZoomScale(1);
    setSelectedIndex(null);
  };

  /* 🔍 ZOOM */
  const toggleZoom = () => {
    setZoomScale((prev) => (prev === 1 ? 2 : 1));
  };

  const handleWheelZoom = (e) => {
    e.preventDefault();
    setZoomScale((prev) => {
      const next = prev + (e.deltaY < 0 ? 0.2 : -0.2);
      return Math.min(Math.max(next, 1), 4);
    });
  };

  const handleShare = async () => {
    try {
      const pageUrl = window.location.href;
      const payload = {
        subfolder,
        pageUrl,
        generatedBy: userData?.Name,
      };

      performRequest("POST", "/farmMedia/shareFarmTrainingMedia", payload)
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Farm media created successfully!");
            // navigate(`/view-farmTraining-media`);
          } else {
            Toast("error", "Error while Creating");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    } catch (error) {}
  };

  const handleManualShare = async () => {
    try {
      if (!senderName || !whatsappNo) {
        Toast("error", "Please fill all fields");
        return;
      }

      setLoading(true);
      const pageUrl = window.location.href;

      const payload = {
        senderName,
        whatsappNo,
        subfolder,
        pageUrl,
        generatedBy: userData?.Name,
      };

      const res = await performRequest(
        "POST",
        "/farmMedia/manuallyShareFarmTrainingMedia",
        payload
      );

      if (res.status === 200) {
        Toast("success", "Farm media shared successfully!");
        setShowManualModal(false); // ✅ CLOSE MODAL
        setSenderName("");
        setWhatsappNo("");
      } else {
        Toast("error", "Error while sharing");
      }
    } catch (err) {
      CustomErrorResponse(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingPage />;

  const selectedMedia =
    selectedIndex !== null ? mediaList[selectedIndex] : null;

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcMultipleCameras className="fs-2 me-1" />
                  Farm Training Gallery
                </h2>
                <h4 className="text-muted">
                  Images & videos from training sessions
                </h4>
              </div>
              <div className="col-md-4 text-md-end mt-3 mt-md-0">
                <div className="btn-group">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => setShowManualModal(true)}
                  >
                    <FaPaperPlane className="me-1" />
                    Manually Send
                  </button>
                  {isAdmin && (
                    <>
                      <button
                        className="btn btn-outline-secondary"
                        onClick={handleShare}
                      >
                        <FaShareAlt className="me-1" />
                        Share
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          navigate(
                            `/update-perFolder-farmTraining-media/${subfolder}`
                          )
                        }
                      >
                        <FaPlus className="me-1" />
                        Add Media
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row g-3">
            {mediaList.map((item, index) => (
              <div key={index} className="col-lg-2 col-md-3 col-sm-4 col-6">
                <div
                  className="card cursor-pointer"
                  onClick={() => setSelectedIndex(index)}
                >
                  <div className="ratio ratio-1x1 bg-light">
                    {item.resource_type === "image" ? (
                      <img
                        src={item.url}
                        loading="lazy"
                        className="w-100 h-100 object-fit-cover"
                        alt=""
                      />
                    ) : (
                      <video
                        src={item.url}
                        muted
                        className="w-100 h-100 object-fit-cover"
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className={`modal modal-blur fade ${
            selectedIndex !== null ? "show d-block" : ""
          }`}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content bg-transparent border-0 position-relative">
              <button
                type="button"
                className="btn btn-dark position-absolute top-0 end-0 m-3 rounded-circle"
                style={{ zIndex: 1056 }}
                onClick={closeModal}
              >
                ✕
              </button>
              <div className="modal-body text-center position-relative p-0 bg-transparent">
                {mediaList.length > 1 && (
                  <button
                    className="btn btn-dark position-absolute top-50 start-0 translate-middle-y rounded-circle"
                    style={{ marginLeft: "12px", zIndex: 1056 }}
                    onClick={prevMedia}
                  >
                    <FaArrowLeft />
                  </button>
                )}
                {selectedMedia?.resource_type === "image" ? (
                  <img
                    src={selectedMedia.url}
                    alt=""
                    onClick={toggleZoom}
                    onWheel={handleWheelZoom}
                    className="img-fluid"
                    style={{
                      maxHeight: "75vh",
                      cursor: zoomScale > 1 ? "zoom-out" : "zoom-in",
                      transform: `scale(${zoomScale})`,
                      transition: "transform 0.3s ease",
                    }}
                  />
                ) : (
                  <video
                    ref={videoRef}
                    src={selectedMedia?.url}
                    controls
                    autoPlay
                    className="w-100"
                    style={{ maxHeight: "75vh" }}
                  />
                )}
                {mediaList.length > 1 && (
                  <button
                    className="btn btn-dark position-absolute top-50 end-0 translate-middle-y rounded-circle"
                    style={{ marginRight: "12px", zIndex: 1056 }}
                    onClick={nextMedia}
                  >
                    <FaArrowRight />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        {selectedIndex !== null && (
          <div className="modal-backdrop fade show"></div>
        )}
        {showManualModal && (
          <>
            <div className="modal modal-blur fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-sm modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Manually Send</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowManualModal(false)}
                    />
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Client Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter client name"
                        value={senderName}
                        onChange={(e) => setSenderName(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">WhatsApp Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter WhatsApp number"
                        value={whatsappNo}
                        onChange={(e) => setWhatsappNo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowManualModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleManualShare}
                      disabled={loading}
                    >
                      <FaPaperPlane className="me-1" />
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade show"></div>
          </>
        )}
        <Footer />
      </div>
    </div>
  );
};

export default ViewPerFolderFarmMedia;
